/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
// dependancys
import React, { useState, useEffect, useRef } from "react";
import { useGlobal } from "reactn";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

// components
import GlobalError from "shared-anpost-components/components/globalError/GlobalError";
import DetectDeviceResize from "shared-anpost-components/hooks/detectDeviceResizeHook";

import Header from "../../_core/Header/Header";
import TabMenu from "../../_core/Tabs/TabMenu";
import Error from "../../_common/error/Error";

// containers
import AccountContainerStyled from "../../_common/containers/AccountContainer/AccountContainer.styled";

// hooks
import profileHooks from "../../../hooks/profileHooks";
import LoginFlow from "../_loginFlow/LoginFlow";
import { hasApplicationCode, getCookie } from "../../../helpers/Helpers";
import AddressHooks from "../../../hooks/addressHooks";
import LoginHook from "../../../hooks/LoginHooks";

import { ContentContainerStyled } from "../../_common/contentContainer/ContentContainer.styled";

// api
import { getProfile, getJWTInfo, createCustomer, getAutoDib } from "../../../services/Api";
import MyDeliveries from "./myDeliveries";
import MyDeliveriesFaq from "./faq/MyDeliveriesFaq";
import DeliveryBackup from "./deliveryBackup";
import MobileTopBar from "../../_core/MobileTopBar/MobileTopBar";

const HomePage = ({ history, openTab }) => {
    const { setActiveTab, values } = profileHooks();
    const location = useLocation();
    // states
    const [apiError, setApiError] = useState(false);
    const [loader, setLoader] = useState(false);
    const [homepageActiveTab, setHomepageActiveTab] = useState(null);
    const [userProfile, setProfile] = useGlobal("userProfile");
    const [businessname, setBusinessname] = useGlobal("businessName");
    const [isBusiness, setIsBusiness] = useGlobal("isBusiness");
    const [firstname, setFirstname] = useGlobal("firstName");
    const [lastname, setLastname] = useGlobal("lastName");
    const [userEmail, setUserEmail] = useGlobal("email");
    const [isCollapsed] = useGlobal("isCollapsed");
    const [showMobileBanner, setShowMobileBanner] = useGlobal("mobileBanner");
    const [hasNotification, setHasNotification] = useState(false);
    const [sideNavIndex, setSideNavIndex] = useGlobal("sideNavIndex");
    const [userIsRegisteredToMyDelApp, setUserIsRegisteredToMyDelApp] = useGlobal("userIsRegisteredToMyDelApp");
    const [isAnPostApp] = useGlobal("isAnPostApp");
    const [refetch, setRefetch] = useGlobal("refetch");
    const [profileData, setProfileData] = useState({});
    const [profileAddresses, setProfileAddresses] = useState({});
    const [customerCreated, setCustomerCreated] = useState(false);
    const [autoDIB, setAutoDIB] = useState({});
    const { filterHomeAddresses } = AddressHooks();

    const tabMenuItems = [
        { key: "my-deliveries", label: "My Deliveries", link: "/" },
        { key: "delivery-backup", label: "Delivery Backup", notification: hasNotification, link: "/delivery-backup" },
        { key: "faq", label: "FAQs", link: "/faq" }
    ];

    // hooks
    const { isMobile } = DetectDeviceResize();

    const hasMounted = useRef(false); // To track initial mount

    // close error banner
    const closeFunc = () => {
        setApiError(false);
    };

    const hideBenefitsTab = () => {
        if (document.querySelector(".m04")) {
            document.querySelector(".m04").classList.add("m04--hidden");
        }
    };

    const getProfileCallback = (profileResponse, callback) => {
        const { addresses, profile, email, uid, applications } = profileResponse;

        setProfileData(profileResponse);
        setProfileAddresses(filterHomeAddresses(addresses));
        sessionStorage.setItem("userProfile", JSON.stringify(profileResponse));

        if (callback) {
            callback(profile.firstName || email);
        }

        if (!hasApplicationCode(applications, "anpost_mydeliveries")) {
            const data = {
                customerName: uid
            };

            setLoader(true);
            createCustomer(uid, data).then(res => {
                if (res && res.data && res.status === 201) {
                    const { success } = res.data;
                    if (success) {
                        setCustomerCreated(true);
                        getProfile(uid).then(res => {
                            if (res.status === 200) {
                                sessionStorage.setItem("userProfile", JSON.stringify(res.data));
                                setUserIsRegisteredToMyDelApp(true);
                            }
                        });
                    }
                } else {
                    setApiError(true);
                }
            });
        } else {
            setCustomerCreated(true);
            setUserIsRegisteredToMyDelApp(true);
        }

        setLoader(false);
    };

    const getProfileInfo = (UID, callback, apiProfileData) => {
        const profileData = apiProfileData || JSON.parse(sessionStorage.getItem("userProfile"));
        setLoader(true);
        if (values.userIsVerified) {
            hideBenefitsTab();
        }

        if (profileData) {
            getProfileCallback(profileData, callback);
        } else {
            getJWTInfo().then(() => {
                getProfile(UID).then(res => {
                    if (res.status === 200) {
                        getProfileCallback(res.data, callback);
                    } else {
                        setApiError(true);
                        setLoader(false);
                    }
                });
            });
        }
    };

    useEffect(() => {
        if (window.apDevMode || values.loggedIn) {
            getAutoDib(values.ciamUserId).then(res => {
                setAutoDIB(res.data.autoDIB.filter(el => el.emailAddress));
                const hasAutoDib = res.data.autoDIB.filter(el => el.emailAddress);
                if (!hasAutoDib.length) {
                    setHasNotification(true);
                } else {
                    setHasNotification(false);
                }
            });
            getProfileInfo(values.ciamUserId);
        }
    }, [userIsRegisteredToMyDelApp, refetch]);

    // check if user has business account and set url to /business if not already set
    const checkForBusinessAcc = businessNameInfo => {
        if (businessNameInfo && window.location.pathname.endsWith("/") && !window.location.pathname.includes("Business")) {
            !isBusiness && setIsBusiness(true);
            if (!getCookie("switch_profile")) {
                document.cookie = "switch_profile=true";
            }

            history.push("/Business");
        }
    };

    // get data from session storage
    // this function is called on first page load or after login
    const getProfileData = (profileResponse, callback) => {
        setLoader(true);
        getJWTInfo().then(() => {
            const profileData = JSON.parse(sessionStorage.getItem("userProfile")) || profileResponse;
            setProfile(profileData);
            const { profile, email, applications, phones } = profileData;
            checkForBusinessAcc(profile.business.name);
            setBusinessname(profile.business.name);
            setFirstname(profile.firstName);
            setLastname(profile.lastName);
            setUserEmail(email);
            getProfileCallback(profileData, callback);
            setLoader(false);

            // check if there are any phone numbers, and if so show the mobile banner
            if (phones.length === 0 && !showMobileBanner) {
                setShowMobileBanner(true);
            }
        });
    };

    const checkTab = () => {
        const tab = openTab || null;
        if (tab) {
            setActiveTab(tab);
            setSideNavIndex(1);
            setHomepageActiveTab(tab);
        }
    };

    useEffect(() => {
        if (hasMounted.current) {
            if (!values.loggedIn) {
                const queryParams = new URLSearchParams(window.location.search);
                const trackingNumber = queryParams.get("trackingNumber") || queryParams.get("t");

                if (!trackingNumber) {
                    window.location.href = "/Post-Parcels/Receiving/My-deliveries";
                } else {
                    window.location.href = `/Post-Parcels/Track/History?item=${trackingNumber}`;
                }
            }
        } else {
            hasMounted.current = true;
        }
    }, [values.loggedIn]);

    useEffect(() => {
        checkTab();

        if (isBusiness && homepageActiveTab === "my-deliveries" && !window.location.pathname.includes("Business")) {
            !isBusiness && setIsBusiness(true);
            history.push("/Business");
        }

        if (homepageActiveTab === "my-deliveries" && !window.location.pathname.includes("Business") && getCookie("switch_profile")) {
            !isBusiness && setIsBusiness(true);
            history.push("/Business");
        }

        if ((window.location.pathname.includes("Business") || getCookie("switch_profile")) && !isBusiness) {
            setIsBusiness(true);
        }
    }, []);

    // set datalayer dashboard type
    useEffect(() => {
        window.dataLayer.push({
            dashboardType: isBusiness ? "Business" : "Personal"
        });
    }, [isBusiness]);

    // change page title in webview navigaton depending on selected tab
    useEffect(() => {
        const appPageNameParagraph = document.querySelector(".app-header__page-name p");
        if (!appPageNameParagraph || !isAnPostApp) return;
        let pageTitle = "My Deliveries";

        if (homepageActiveTab === "delivery-backup") {
            pageTitle = "Delivery Backup";
        } else if (homepageActiveTab === "faqs") {
            pageTitle = "FAQs";
        }

        appPageNameParagraph.innerHTML = pageTitle;
    }, [homepageActiveTab]);

    const shouldShowTabMenu = !isAnPostApp;

    return (
        <>
            <div>
                <LoginFlow loginCompleteCallback={getProfileData} />
                {apiError && <GlobalError closeFunc={closeFunc} />}
                <AccountContainerStyled>
                    {isMobile && !isAnPostApp && <MobileTopBar isOverview={true} history={history} />}
                    <>
                        {!values.loggedIn && window.apDevMode && <Error errorHeading="You are not logged in. You need to be logged into your An Post account to view this page." loginPrompt></Error>}
                        {values.loggedIn && (
                            <>
                                {<Header businessName={businessname} firstName={firstname} values={values} email={userEmail} isMobile={isMobile} history={history} />}
                                {shouldShowTabMenu && <TabMenu tabMenuItems={tabMenuItems} history={history} isBusiness={isBusiness} />}
                                <ContentContainerStyled isBackup={homepageActiveTab === "delivery-backup"}>
                                    {homepageActiveTab === "my-deliveries" && <MyDeliveries />}
                                    {homepageActiveTab === "delivery-backup" && <DeliveryBackup history={history} autoDIB={autoDIB} />}
                                    {homepageActiveTab === "faq" && (
                                        <>
                                            <MyDeliveriesFaq />
                                        </>
                                    )}
                                </ContentContainerStyled>
                            </>
                        )}
                    </>
                </AccountContainerStyled>
            </div>
        </>
    );
};

export default HomePage;
HomePage.propTypes = {
    history: PropTypes.object,
    openTab: PropTypes.string,
    profileTab: PropTypes.string
};
